import { themeI18n } from '../utils/i18n_helper.js';
import { formatHour } from '../utils/time.js';
import '../../styles/components/store-drawer-location.scss';
import Icons from './Icons.js';
import { multilingual_url } from '../utils/multilingual-url.js';

export const StoreDrawerLocation = ({ store, storeInventory, myStoreLocation, first }) => {
  const pickupStatus = storeInventory && storeInventory.available && storeInventory.pick_up_enabled ? 'in-stock' : 'sold-out';
  const inStoreStatus = storeInventory && storeInventory.available ? 'in-stock' : 'sold-out';

  const handleStoreLocationClick = (event) => {
    const target = event.target;

    if (myStoreLocation != store.id && target.className != 'store-drawer-location__store-details') {
      localStorage.setItem('theme:my_store', store.id);
      window.dispatchEvent(new CustomEvent('myStoreChanged', { detail: store.id }));
    }
  }

  return (
    <button
      className={`store-drawer-location ${myStoreLocation == store.id ? 'store-drawer-location--my-store': null}`}
      onClick={(event) => handleStoreLocationClick(event)}
      style={{order: first ? -1 : null}}
    >
      <div className='store-drawer-location__name-wrapper'>
        <p className='store-drawer-location__name' >{store.name}</p>

        {myStoreLocation == store.id ? (
          <Icons icon='checkbox-checked' size='small' />
        ): (
          <Icons icon='checkbox' size='small' />
        )}
      </div>

      <p className='store-drawer-location__address store-drawer-location__info'>{store.address}</p>

      {store.distance && (
        <p className='store-drawer-location__distance store-drawer-location__info' title={themeI18n('store_locator.distance')}>
          {store.distance ? `${store.distance.toFixed(2)} km` : null}
        </p>
      )}

      <div className='store-drawer-location__open-indicator-wrapper'>
        <OpenIndicator store={store} />
        <a href={multilingual_url(`/pages/store/${store.handle}`)} className='store-drawer-location__store-details'>
          {themeI18n('store_locator.store_details')}
        </a>
      </div>

      {storeInventory && (
        <div className='store-drawer-location__inventory-status'>
          <div className={`store-drawer-location__pickup-status ${pickupStatus}`}>
            <div className='store-drawer-location__pickup-satus-icon' />

            {pickupStatus == 'in-stock' ? themeI18n('products.inventory.pickup_available') : themeI18n('products.inventory.pickup_unavailable')}
          </div>

          <div className={`store-drawer-location__pickup-status ${inStoreStatus}`}>
            <div className='store-drawer-location__pickup-satus-icon' />

            {storeInventory.available ? themeI18n('products.inventory.available_in_store') : themeI18n('products.inventory.unavailable_in_store')}
          </div>
        </div>
      )}
    </button>
  )
}

const OpenIndicator = ({ store }) => {
  const currentDay = new Date().getDay();
  const currentDate = new Date();
  const storeHours = {};
  const dayHoursKeys = ['sunday_hours', 'monday_hours', 'tuesday_hours', 'wednesday_hours', 'thursday_hours', 'friday_hours', 'saturday_hours'];

  dayHoursKeys.forEach((day, index) => {
    storeHours[index] = {
      open: store[day]?.split("-")[0].split(":")[0],
      openMinutes: store[day]?.split("-")[0].split(":")[1],
      close: store[day]?.split("-")[1].split(":")[0],
      closeMinutes: store[day]?.split("-")[1].split(":")[1]
    }
  });

  const storeOpeningDate = new Date();
  storeOpeningDate.setHours(storeHours[currentDay].open);
  storeOpeningDate.setMinutes(storeHours[currentDay].openMinutes);
  const storeClosingDate = new Date();
  storeClosingDate.setHours(storeHours[currentDay].close);
  storeClosingDate.setMinutes(storeHours[currentDay].closeMinutes);


  const isOpen = currentDate >= storeOpeningDate && currentDate <= storeClosingDate && storeHours[currentDay].close && storeHours[currentDay].open;

  if (isOpen) {
    return (
      <span className='store-drawer-location__open-indicator'>
        <span className='store-drawer-location__open-indicator-text-blurb'>
          <span className='store-drawer-location__open-indicator-highlight store-drawer-location__open-indicator-highlight--open'>
            {themeI18n('store_locator.open')}
          </span>
          {themeI18n('store_locator.until')}
          {formatHour(storeHours[currentDay].close, storeHours[currentDay].closeMinutes)}
        </span>
      </span>
    )
  } else {
    const isOpeningLater = currentDate < storeOpeningDate;

    if (isOpeningLater) {
      return (
        <span className='store-drawer-location__open-indicator'>
          <span className='store-drawer-location__open-indicator-text-blurb'>
            <span className='store-drawer-location__open-indicator-highlight store-drawer-location__open-indicator-highlight--closed'>
              {themeI18n('store_locator.closed')}
            </span>
            {themeI18n('store_locator.opens_at')}
            {formatHour(storeHours[currentDay].open, storeHours[currentDay].openMinutes)}
          </span>
        </span>
      )
    } else {
      let nextOpenDay;

      for (let i = currentDay + 1; i <= 6; i++) {
        if (storeHours[i].open) {
          nextOpenDay = i;
          break;
        }
      }

      if (!nextOpenDay) {
        for (let i = 0; i <= currentDay; i++) {
          if (storeHours[i].open) {
            nextOpenDay = i;
            break;
          }
        }
      }

      return (
        <span className='store-drawer-location__open-indicator'>
          <span className='store-drawer-location__open-indicator-text-blurb'>
            <span className='store-drawer-location__open-indicator-highlight store-drawer-location__open-indicator-highlight--closed'>
              {themeI18n('store_locator.closed')}
            </span>
            {themeI18n('store_locator.opens_on')}
            {themeI18n(`store_locator.days.${nextOpenDay}`)}
            {themeI18n('store_locator.at')}
            {formatHour(storeHours[nextOpenDay].open, storeHours[nextOpenDay].openMinutes)}
          </span>
        </span>
      )
    }
  }
}
